import { ReactNode } from 'react';

export interface EnvironmentChipProps {
  icon: ReactNode;
  value: string;
  label: string;
}

/** One "icon + value + caption" chip in the topbar's environment cluster (ambient temp, humidity, clock). */
export function EnvironmentChip({ icon, value, label }: EnvironmentChipProps) {
  return (
    <div className="flex items-center gap-1.5 text-text-secondary">
      {icon}
      <div className="leading-tight">
        <p className="font-mono text-xs font-semibold text-text-primary">{value}</p>
        <p className="text-[9.5px] text-text-secondary">{label}</p>
      </div>
    </div>
  );
}
